"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imagePreviewThumbSize = exports.imagePreviewDetailSize = exports.bytesInKb = exports.SEARCH_DELAY = exports.REGISTRATION_STATE = exports.PROJECT_NAME = exports.NAMES = exports.MAX_SEARCH_TEXT_LENGTH = exports.MAX_SEARCH_OPTIONS = exports.KycAddressType = exports.KEY_UP = exports.KEY_RIGHT = exports.KEY_LEFT = exports.KEY_DOWN = exports.GridSize = exports.DEFAULT_ADDRESS_TYPE = exports.ARROW_KEYS = void 0;
// keyboard keys
const KEY_LEFT = exports.KEY_LEFT = 37;
const KEY_RIGHT = exports.KEY_RIGHT = 39;
const KEY_UP = exports.KEY_UP = 38;
const KEY_DOWN = exports.KEY_DOWN = 40;
const ARROW_KEYS = exports.ARROW_KEYS = [KEY_LEFT, KEY_RIGHT, KEY_UP, KEY_DOWN];
const bytesInKb = exports.bytesInKb = 1024;
const imagePreviewThumbSize = exports.imagePreviewThumbSize = 80;
const imagePreviewDetailSize = exports.imagePreviewDetailSize = 500;
const MAX_SEARCH_OPTIONS = exports.MAX_SEARCH_OPTIONS = 100;
const MAX_SEARCH_TEXT_LENGTH = exports.MAX_SEARCH_TEXT_LENGTH = 100;
const SEARCH_DELAY = exports.SEARCH_DELAY = 300;
const PROJECT_NAME = exports.PROJECT_NAME = 'address-form';
const REGISTRATION_STATE = exports.REGISTRATION_STATE = 'Pending';
const DEFAULT_ADDRESS_TYPE = exports.DEFAULT_ADDRESS_TYPE = 'Delivery';
const KycAddressType = exports.KycAddressType = 'Kyc';
let GridSize = exports.GridSize = /*#__PURE__*/function (GridSize) {
  GridSize[GridSize["Full"] = 12] = "Full";
  GridSize[GridSize["Half"] = 6] = "Half";
  GridSize[GridSize["Quarter"] = 3] = "Quarter";
  GridSize[GridSize["Sixth"] = 2] = "Sixth";
  GridSize[GridSize["Third"] = 4] = "Third";
  GridSize[GridSize["TwoThirds"] = 8] = "TwoThirds";
  GridSize[GridSize["ThreeQuarters"] = 9] = "ThreeQuarters";
  return GridSize;
}({});
const NAMES = exports.NAMES = {
  AUTOCOMPLETE: 'autocompleteV2',
  COUNTRY: 'country',
  STREET_ADDRESS: 'streetAddress',
  ZIPCODE: 'zipcode',
  CITY: 'city',
  PROVINCE: 'province',
  DELIVERY: 'delivery',
  DELIVERY_2: 'delivery2',
  DELIVERY_3: 'delivery3',
  AREA: 'area',
  LOCALITY: 'locality',
  DISTRICT: 'district',
  REGION: 'region',
  ADDRESS_TYPE: 'addressType',
  IS_PRIMARY: 'isPrimary'
};
//# sourceMappingURL=constants.js.map